import { registerComponent } from './components-front'

registerComponent('background-image', _ => {

})
